import { defineStore } from 'pinia'
import { useCacheStore } from '~/store/cache'

export const useTranslationStore = defineStore('translation', () => {
  const config = useRuntimeConfig()

  const locale = ref<string>('nl')
  const translations = ref<Record<string, any>>({})

  function set({ locale: l, translations: t }: { locale: string; translations: Record<string, any> }) {
    locale.value = l
    translations.value = t
  }

  async function load({ locale }: { locale: string }) {
    const key = `translations;${locale}`
    const ttl = 3600

    const fetcher = async () => {
      // Unable to use "cmsFetch" here because this plugin is not yet available when i18n calls this store action
      const response = await (await fetch(`${config.public['cmsSiteUrl']}/api/site/default/translations.json`)).json()
      // Merge the static translations from disk with the dynamic translations from the database.
      // The fetched dataset holds "flat" keys, so we need to convert them into nested objects before merging.
      const result: Record<string, string | Record<string, any>> = {}
      for (const entry of response.data) {
        if (!entry.key.includes('.')) {
          result[entry.key] = entry.value
          continue
        }
        const parts = entry.key.split('.')
        let current = result
        for (let i = 0; i < parts.length; i++) {
          const part = parts[i]
          if (i === parts.length - 1) {
            current[part] = entry.value
          } else {
            current[part] = part in current && typeof current[part] === 'object' ? current[part] : {}
            current = current[part]
          }
        }
      }
      return result
    }

    const cacheStore = useCacheStore()
    const translations = await cacheStore.fetch({ key, ttl, fetcher })
    set({ locale, translations })

    return translations
  }

  return { locale, translations, load }
})
